import { render, staticRenderFns } from "./GameInfos.vue?vue&type=template&id=d86d9650"
import script from "./GameInfos.vue?vue&type=script&lang=js"
export * from "./GameInfos.vue?vue&type=script&lang=js"
import style0 from "./GameInfos.vue?vue&type=style&index=0&id=d86d9650&prod&lang=scss"
import style1 from "./GameInfos.vue?vue&type=style&index=1&id=d86d9650&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports